export default "__VITE_ASSET__BeeJnjW6__"